<template>
    <div class="position-relative">
        <div class="content-wrapper">
            <app-breadcrumb :page-title="$t('default')" :directory="$t('dashboard')" 
                            :icon="'pie-chart'" v-if="this.$can('view_escort_dashboard_info')"/>
            <app-overlay-loader v-if="preloader"/>
            <div class="row" v-else-if="this.$can('view_escort_dashboard_info')">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3"
                        v-for="(item, index) in info" :key="index">
                    <app-widget class="mb-primary"
                        :type="'app-widget-with-icon'"
                        :label="$t(item.label)"
                        :number="item.value"
                        :icon="item.icon"
                    />
                </div>
                <div class="col-12 col-md-12 mb-primary">
                    <div class="card card-with-shadow border-0 h-100">
                        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                            <h5 class="card-title mb-0">{{ $t('escort_overview') }}</h5>
                            <ul class="nav tab-filter-menu justify-content-flex-end">
                                <li class="nav-item" v-for="(item, index) in chartFilterOptions"
                                    :key="index">
                                    <a href="#"
                                       class="nav-link py-0"
                                       :class="[filter == item ? 'active' : index == 0 && filter == '' ? 'active': '']"
                                       @click.prevent="setFilter(item)">
                                        {{ $t(item) }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body position-relative">
                            <app-overlay-loader v-if="!overviewChart && !mainPreloader"/>
                            <app-chart class="mb-primary"
                                    v-if="overviewChart && chartData.labels && chartData.labels.length"
                                    type="custom-line-chart"
                                    :height="200"
                                    :labels="chartData.labels"
                                    :data-sets="chartData.datasets"/>
                            <div v-else-if="overviewChart" class="text-center text-muted py-5">
                                {{ $t('overview_chart_unavailable') }}
                            </div>
                        </div>
                        <div class="chart-data-list d-flex flex-wrap justify-content-center pb-4">
                            <div class="data-group-item" style="color: #EE7228;">
                                <span class="square" style="background-color: #EE7228;"/>
                                {{ $t('trucks_loaded') }}
                            </div>
                            <div class="data-group-item" style="color: #42A5F5;">
                                <span class="square" style="background-color: #42A5F5;"/>
                                {{ $t('trucks_dispatched') }}
                            </div>
                            <div class="data-group-item" style="color: #ef4444;">
                                <span class="square" style="background-color: #ef4444;"/>
                                {{ $t('reported_incidents') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="text-center">
                    <div class="card p-4 mx-auto">
                         <center>
                            <img
                                width="100"
                                :src="configData.company_logo ?
                                    urlGenerator(configData.company_logo) :
                                    urlGenerator('/images/core.png')"
                                alt="" class="img-fluid logo">
                         </center>
                        <h5 class="mt-4">ONLINE ESCORT SYSTEM</h5>
                        <p>Bienvenue sur le système de gestion électronique de l'Escorte</p>
                        <a href="/app-trackings"
                           class="text-primary mt-4"
                        >
                            <app-icon 
                                name="arrow-right"
                            />
                            Afficher les Trackings
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from '../../../../core/mixins/form/FormMixin';
    import * as actions from '../../../Config/ApiUrl';
    import { urlGenerator } from '../../../Helpers/AxiosHelper';
    import { DashboardPreloader } from './Mixins/DashboardPreloader';

    export default {

        mixins: [FormMixin,DashboardPreloader],
        name: "Dashboard",
        props: {
            configData: {
                type: Object
            }
        },
        data() {
            return {
                urlGenerator,
                mainPreloader: true,
                overviewChart: false,
                preloader: false,
                
                audienceChart: false,
                defaultData: false,
                /* end */

                filter: 'last_year',

                chartFilterOptions: [
                    'last_year', 'this_year', 'last_month', 'this_month', 
                ],
                
                info: {},

                chartData: {},
                
            }
        },
        created() {
            this.getDefaultDashboardInfo();
            this.getOverviewData();
        },
        methods: {
            setFilter(filter) {
                this.filter = filter;
                this.overviewChart = false;
                this.getOverviewData();
            },

            getDefaultDashboardInfo() {
                this.preloader = true;
                let url = actions.ESCORT_DASHBOARD_INFO;
                this.axiosGet(url).then(response => {
                    this.preloader = false;
                    this.mainPreloader = false;
                    this.info = response.data;
                }).catch(({response}) => {
                    this.preloader = false;
                    this.mainPreloader = false;
                });
            },

            getOverviewData() {

                let url = "escort-overview-chart", reqData = {};

                reqData.params = {
                    filter: this.filter
                };

                this.axiosGet(
                    url,
                    reqData
                ).then((response) => {
                    this.chartData = response.data;
                    this.overviewChart = true;
                }).catch(({}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                });
            },

        }
    }
</script>
